import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { tokenKey } from '../utils/index'
import Cookies from 'js-cookie'
import md5 from 'crypto-md5'
import Crypto from 'utils/crypto'

const service = axios.create({
  // baseURL: process.env.baseUrl
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.data && config.data.token) {
      config.headers.accessToken = config.data.token
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return Promise.resolve(response)
    }
    const res = response.data
    const params = response.config.data ? JSON.parse(response.config.data) : {}
    if (res.resultCode === '0') {
      return Promise.resolve(res)
    } else if (res.resultCode === "9978") { // 登录失效
      return Promise.reject(res)
    } else {
      Message({
        message: res.resultMsg || res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res)
    }
  },
  error => {
    if (error.response.status === 401) {
      redirect()
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export const axiosAjax = (url, params, option, isBlob) => {
  let accessToken = ''
  params = params || {}
  const pid = "pid.member";
  const pcode = "CGz2RFHATB3XAsvg";
  const pmd5 = md5((pid + pcode).toUpperCase(), "hex");
  const param = JSON.stringify(params) + pmd5.toUpperCase();
  const timestamp = new Date().valueOf();
  const sign = md5(param + timestamp, "hex");
  let appId = "99999999";
  let version = ''
  let frontUrl
  try {
    frontUrl = window.location.href
  } catch (e) {
    frontUrl = option ? option.frontUrl : 'member'
  }
  try {
    accessToken = Cookies.get(tokenKey)
  } catch (e) {
  }
  const headers = {
    "Content-Type": "application/json",
    operatorSource: 'web',
    pid,
    pcode,
    pmd5,
    timestamp,
    sign,
    appId,
    frontUrl,
    version
  }
  // console.log(headers)
  if (accessToken) {
    headers.accessToken = accessToken
  } else {
    // TIC-5967 附加空token到服务端
    headers.accessToken = null
  }
  if (process.env.version === 'gray' || process.env.version === 'prodGray') {
    headers.version = 'gray'
  }
  const data = {
    method: option && option.method || 'post',
    url: url,
    data: params,
    params: option && option.method ? params : {},
    headers: option && option.headers || headers,
  }
  data.headers.system = 'member'
  if (isBlob) {
    data.responseType = 'blob'
  }
  return service(data)
}

/* 
  请求ticNode中间层接口
*/
export const nodeAjax = (params, url, option) => {
  const timestamp = new Date().valueOf()
  const sign = Crypto.encrypt(timestamp, 'sgsonline.com.cn')
  let frontUrl
  let si
  let accessToken
  try {
    frontUrl = window.location.href
    si = localStorage.getItem('sessionId')
    accessToken = Cookies.get(tokenKey)
  } catch (e) {
    frontUrl = option ? dominUrl + option.frontUrl : 'ticPortal'
  }
  console.log(frontUrl, option);
  return axios({
    method: option && option.method || 'post',
    url,
    data: params,
    headers: {
      "Content-Type": "application/json",
      timestamp,
      sign,
      frontUrl,
      si,
      // appId: 99999999,
      accessToken: accessToken || null
    }
  })
    .then(res => {
      if (res.status === 200 && res.data.resultCode === '0') {
        return res.data
      }
    })
    .catch(err => {
      return err;
    })
}

// kilian 接口
export const ajaxNew = (url, params, method, option, isBlob) => {
  let ticHost = '',
      pid = 'pid.mall',
      pcode = 'Z0zCnRE3IaY9Kzem'
  if (!option) {
    ticHost = 'ticMember'
  } else {
    ticHost = option.type
  }

  const timestamp = new Date().valueOf()
  const pmd5 = md5((pid + pcode).toUpperCase(), 'hex');
  const param = JSON.stringify(params) + pmd5.toUpperCase();
  const sign = md5(param + timestamp, 'hex');

  let appId = '99999999'
  let accessToken = Cookies.get(tokenKey)
  let frontUrl
  let si
  try{
    frontUrl=window.location.href
    si = localStorage.getItem('sessionId')
  }catch (e){
    frontUrl=option?option.frontUrl:'member'
  }
  const headers = {
    'Content-Type': 'application/json',
    sign,
    timestamp,
    pid,
    appId,
    accessToken,
    operatorSource: 'web',
    system: 'member',
    frontUrl,
    si: si || ''
  }
  if(process.env.version === 'gray' || process.env.version === 'prodGray') {
    headers.version = 'gray'
  }
  for (var item in headers) {
    if (!headers[item]) delete headers[item]
  }
  const data = {
    method: method || 'post',
    url: url,
    data: params,
    headers
  }
  if (isBlob) {
    data.responseType = 'blob'
  }
  return axios(data)
      .then(res => {
        debugger
        if (res.status === 200 && res.data.resultCode === '0') {
          return res.data
        }else{
          return res.data
        }
      })
      .catch(err => {
        debugger
        return err;
      })
}
